import { CheckInFields, CheckInFieldDefinition } from "../constant/check-in-constant";
import _ from 'underscore'

/** A custom check-in field configured for an account. */
export interface CustomCheckInField {
    checkInFieldType: keyof typeof CheckInFields;
    required?: boolean;
    defaultValue?: string;
}

interface FieldConfigAndDescriptor {
    fieldConfig: CustomCheckInField;
    fieldDescriptor: CheckInFieldDefinition;
}

export const validateCustomCheckInConfiguration = (state: Record<string, unknown>, checkInFields: CustomCheckInField[]): string | null => {
    const fieldNameToFieldConfigAndDescriptor: Record<string, FieldConfigAndDescriptor> = {}
    _.each((checkInFields), (field) => {
        const fieldDescriptor = CheckInFields[field.checkInFieldType]
        fieldNameToFieldConfigAndDescriptor[fieldDescriptor.field] = { fieldConfig: field, fieldDescriptor }
    })

    let errorMessage: string | null = null

    _.find(Object.keys(state), (stateField) => {
        if(fieldNameToFieldConfigAndDescriptor[stateField]) {
            const fieldConfigAndDescriptor = fieldNameToFieldConfigAndDescriptor[stateField]
            const { fieldConfig, fieldDescriptor } = fieldConfigAndDescriptor

            if(fieldConfig.required && !state[stateField]) {
                errorMessage = fieldDescriptor.requiredMessage
                return true
            }
        }
        return false
    })

    return errorMessage
}

export const generateInitialStateFromCustomCheckinConfiguration = (checkInFields: CustomCheckInField[]): Record<string, string> => {
    const initState: Record<string, string> = {}

    _.each(checkInFields, (field) => {
        if(field.defaultValue) {
            const fieldDescriptor = CheckInFields[field.checkInFieldType]
            initState[fieldDescriptor.field] = field.defaultValue
        }
    })

    return initState
}
